import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const schoolLevelServiceApi = createApi({
  reducerPath: 'schoolLevelServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['SchoolLevel'],
  endpoints: (builder) => ({
    // Fetch all school levels
    getAllSchoolLevels: builder.query({
      query: () => '/backoffice/school-levels',
      providesTags: (result) => (result ? [{ type: 'SchoolLevel', id: 'LIST' }] : []),
    }),
    // Fetch a school level by ID
    getSchoolLevelById: builder.query({
      query: (id) => `/backoffice/school-levels/show/${id}`,
      providesTags: (result, error, id) => [{ type: 'SchoolLevel', id }],
    }),
    // Create a new school level
    addSchoolLevel: builder.mutation({
      query: (newSchoolLevel) => ({
        url: '/backoffice/school-levels/save',
        method: 'POST',
        body: newSchoolLevel,
      }),
      invalidatesTags: [{ type: 'SchoolLevel', id: 'LIST' }],
    }),
    // Update a school level
    updateSchoolLevel: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/backoffice/school-levels/update/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: [{ type: 'SchoolLevel', id: 'LIST' }],
    }),
    // Delete a school level
    deleteSchoolLevel: builder.mutation({
      query: (id) => ({
        url: `/backoffice/school-levels/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'SchoolLevel', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetAllSchoolLevelsQuery,
  useGetSchoolLevelByIdQuery,
  useAddSchoolLevelMutation,
  useUpdateSchoolLevelMutation,
  useDeleteSchoolLevelMutation,
} = schoolLevelServiceApi
